export const URL_GREEN_CARD = '/cards/green',
    URL_PREMIUM_CARD = '/cards/premium',
    URL_YELLOW_CARD = '/cards/yellow',
    URL_ATB_CARD = '/cards/atb',
    URL_PROSTOR_CARD = '/cards/prostor',
    URL_VYGODA_CARD = '/cards/vygoda',
    URL_BOLT_CARD = '/cards/bolt',
    URL_KID_CARD = '/cards/kid-card',
    URL_EVIDNOVLENNIA_CARD = '/cards/eVidnovlennia',
    URL_UKRAININANS_TOGETHER_CARD = '/cards/ukrainians_together',
    URL_CASHBACK_UA_CARD = '/cards/cashback_ua',
    URL_DIIA_CARD = '/cards/diia',
    URL_PROJECT_SUPPORT_CARD = '/cards/project-support',
    URL_GOLD_CARD = '/cards/gold',
    URL_KUN_CARD = '/cards/kun',
    URL_KDV_CARD = '/cards/kdv';
